import { Configuration } from 'src/app/models/configurations/configuration';
import { ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Identifiable } from 'src/app/models/Identifiable';
import { DeploymentClass } from 'src/app/models/instance-class';
import { DataZone } from '../data-zone/data-zone';
import { Endpoint } from '../endpoint';

export enum ManagementMode {
  ADOPTED = 'adopted',
  READ_ONLY = 'read_only'
}

export interface LastOperation {
  id?: string;
  type?: 'provision' | 'provisioning' | 'redeploy' | 'extend' | 'update_base_image' | 'adopt' | 'inventory'
       | 'config' | 'update' | 'infraUpdate' | 'config_rvt_test' | 'rvt_test' | 'ef_test' | 'sanity_test'
       | 'stop' | 'start' | 'delete' | 'failover' | 'pre_fallback' | 'fallback' | 'post_fallback'
       | 'resize' | 'backup_create' | 'backup_update' | 'backup_delete' | 'restore' | 'execute'
       | 'backup' | 'other' | 'initialize'
       | 'cob_config' | 'cob_reconfig' | 'cob_update' | 'cob_delete'
       | 'runbook_provision' | 'runbook_redeploy' | 'runbook_config' | 'runbook_update' | 'runbook_delete'
       | 'schedule_create' | 'schedule_config_update' | 'schedule_enable' | 'schedule_disable' | 'schedule_delete'
       | 'scheduler_version_update' | 'start_agent' | 'stop_agent';
  status?: 'InProgress' | 'inprogress' | 'Succeeded' | 'success' | 'Failed' | 'failed';
}

export interface Instance extends Identifiable {
  parameters?: any;
  tenantId?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  expirationDate?: Date;
  status?: DeployStatus;
  availabilityState?: string;
  lifecycleState?: string;
  lastOperation?: LastOperation;
  solutionId?: string;
  solutionVersionId?: string;
  blueprintId?: string;
  blueprintVersionId?: string;
  latestDeploymentId?: string;
  configurationId?: string;
  deprovisionInstructionId?: string;
  name?: string;
  url?: string;
  endpoints?: Endpoint[];
  region?: string;
  dataZone?: DataZone;
  deploymentClass?: DeploymentClass;
  previousInstance?: any;
  previousEnvironment?: any;
  deployedVersion?: any;
  data?: any;
  agentVersion?: string;
  agentStatus?: string;
  managementMode?: ManagementMode;
  targetEnvironment?: string;
  type?: string;
  sizingDocumentId?: string;


  // UI properties
  environment?: string;
  activeConfiguration?: Configuration;
  configurationStates?: ConfigurationState[];
  latestConfigurationState?: ConfigurationState;
  expanded?: boolean;
  rvtStates?: any;
  latestRvtState?: any;
  serviceDefinitionUpdate?:boolean;
  configurationStatus?:boolean;
  version?: string;
  infraSolutionVersion?: string;
  hasRunningJobs?: boolean;
}

export const AVAILABLE_STATE_ICON = {
  not_ready : 'do_not_disturb_on',
  running : 'run_circle',
  starting : 'motion_photos_on',
  stopping : 'back_hand',
  stopped: 'stop_circle'
}

export const ENVIRONMENT_STATUS_ICON = {
  stopped: 'stop_circle',
  deployed: 'check_circle_filled',
  configured: 'check_circle',
  initialized: 'check_circle',
  updated: 'check_circle',
  tested: 'check_circle',
  failed: 'warning_amber',
  configuration_failed: 'warning_amber',
  terminated: 'error_outline',
  termination_failed: 'warning_amber',
  test_failed: 'warning_amber',
  update_failed: 'warning_amber',
  start_failed: 'warning_amber',
  stop_failed: 'warning_amber',
  initialize_failed: 'warning_amber',
  failover_failed: 'warning_amber',
  pre_failback_failed: 'warning_amber',
  post_failback_failed: 'warning_amber',
  failback_failed: 'warning_amber',
}

export const ENV_PROGRESS_STATUS =['deploying','terminating','configuring','adopting','updating','initializing','operation_inprogress',
  'stopping','stopping_agent','starting','starting_agent','testing','fallback_inprogress','failover_inprogress', 'pre_failback_applying', 'post_failback_applying', 'inprogress', 'aborting'
]
